import { createSlice } from "@reduxjs/toolkit";
import { importAll } from "@/utils/tools";

const initialState = {
  cache: importAll(),
};

export const langSlice = createSlice({
  name: "cache",
  initialState,
  reducers: {
    cacheChange: (state, payload) => {
      state.cache = payload.payload;
    },
  },
});

export default langSlice.reducer;
